module.exports = __webpack_public_path__ + "img/zolly-hotline.95386713.svg";